<template>
  <!-- 項目名と値を横に並べる情報帯（ラベル発注・ラベル数管理の各画面の上部） -->
  <v-sheet class="label-meta-strip rounded" color="grey-lighten-4">
    <div class="d-flex flex-wrap">
      <div v-for="item in items" :key="item.label" class="label-meta-item" :style="item.wide ? 'flex: 2 1 260px;' : ''">
        <div class="text-caption text-medium-emphasis">{{ item.label }}</div>
        <div :class="valueClass(item)">
          <slot :name="item.slot" :item="item">{{ item.value }}</slot>
        </div>
      </div>
    </div>
    <div v-if="note" class="label-meta-note text-body-2">
      <span class="text-medium-emphasis mr-2">{{ noteLabel }}</span>{{ note }}
    </div>
  </v-sheet>
</template>

<script lang="js">
/**
 * items: [{ label, value, muted?, strong?, wide?, slot? }]
 *   muted  … 未確定の値（灰色で表示）
 *   strong … 強調する値
 *   wide   … 幅を広く取る（店舗名など）
 *   slot   … 値をスロットで差し替える（チップを出すなど）
 */
export default {
  props: {
    items: { type: Array, required: true },
    note: { type: String, default: "" },
    noteLabel: { type: String, default: "" },
  },
  methods: {
    valueClass(item) {
      if (item.muted) return "text-body-1 text-disabled";
      return item.strong ? "text-body-1 font-weight-bold" : "text-body-1";
    },
  },
};
</script>

<style scoped>
.label-meta-strip {
  padding: 12px 8px;
}
.label-meta-item {
  flex: 1 1 auto;
  min-width: 120px;
  padding: 4px 14px;
  white-space: nowrap;
}
.label-meta-note {
  padding: 8px 14px 2px;
}
</style>
